import React from 'react'
import { Fragment } from 'react'
import PagesHeading from '../pages-heding/PagesHeading'
import FraFees from '../frafees/FraFees'

const FraFeesPage = (props) => {
  return (
    <Fragment>
        <PagesHeading page_title={props.page_title}></PagesHeading>
        <FraFees></FraFees>
    </Fragment>
  )
}

export default FraFeesPage